import { render } from "./BreadcrumbsSection.vue?vue&type=template&id=42f7e8e8"
import script from "./BreadcrumbsSection.vue?vue&type=script&lang=js"
export * from "./BreadcrumbsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__